import { render, staticRenderFns } from "./AssetsManager.vue?vue&type=template&id=0c50d0cb"
import script from "./AssetsManager.vue?vue&type=script&lang=js"
export * from "./AssetsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports